import gql from 'graphql-tag'
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";

export const notificationFragment = gql`
    fragment notificationFragment on Notification{
        id
        conversation_id
        subject
        message
        info

        created_at
        updated_at
        read
        to {
            # ...userProfileFragments
            id
            name
            email
        }
        type
    }
`